export const optionsdata=[
    {
        title:"जातीनुसार स्थळे"
    },
    {
        title:"नवीन आलेली स्थळे"
    },
    {
        title:"घटस्फोटीत स्थळे"
    },
    {
        title:"शिक्षणानुसार स्थळे"
    },
    {
        title:"माझ्या जिल्ह्यातील स्थळे"
    },
    {
        title:"स्थळे शोधा"
    },
    {
        title:"मला भेट दिलेली स्थळे"
    },
    {
        title:"माझ्या फिल्टर प्रमाणे स्थळे"
    },
    {
        title:"शोर्टलिस्ट केलेली स्थळे"
    },
    {
        title:"काऊंट वापरलेली स्थळे"
    },
    {
        title:"मदतीसाठी पाठविलेली स्थळे"
    },
    
]